import { render, staticRenderFns } from "./tumkayitlar.vue?vue&type=template&id=4ee88fb0"
import script from "./tumkayitlar.vue?vue&type=script&lang=js"
export * from "./tumkayitlar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports